var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import assertIsHTTPMethod from "~/client/utils/assertIsHTTPMethod";
import worker from "~/client/worker";
const fetch = (resource_1, ...args_1) => __awaiter(void 0, [resource_1, ...args_1], void 0, function* (resource, init = {}) {
    const { body, headers, method = "GET" } = init;
    assertIsHTTPMethod(method);
    const response = yield worker.handleRequest({
        method,
        path: resource,
        headers,
        body,
    });
    return new Response(response.body, { status: response.status });
});
export default fetch;
